"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DebtObligationType = exports.MortgageHomeOwnerSource = exports.CashOutAmountLimitReason = exports.isLoanAmortizationTypeSupported = exports.MORTGAGE_BASE_REFINANCE_OFFER_LOAN_AMORTIZATION_TYPES = exports.MortgageQualificationAction = exports.MORTGAGE_INVALID_LIABILITY_SUBTYPES_FOR_DEBT_REFINANCE = exports.MORTGAGE_VALID_LIABILITY_TYPES_FOR_DEBT_REFINANCE = exports.MORTGAGE_LIABILITY_DETAIL_FIELDS = exports.MortgageExtendedApplicationStatus = exports.MortgageUniformResidentialLoanApplicationStatus = exports.MortgageLender = exports.MortgageDifferentOptionLookingFor = exports.StatedRefinanceCashOutType = void 0;
const vesta_1 = require("./vesta");
var StatedRefinanceCashOutType;
(function (StatedRefinanceCashOutType) {
    StatedRefinanceCashOutType["RATE_AND_TERM_REFINANCE"] = "RATE_AND_TERM_REFINANCE";
    StatedRefinanceCashOutType["CASH_OUT_REFINANCE"] = "CASH_OUT_REFINANCE";
})(StatedRefinanceCashOutType || (exports.StatedRefinanceCashOutType = StatedRefinanceCashOutType = {}));
// The "I am looking to" options on the mortgage "Looking for a different option?" page
// (DifferentOption.vue). Kept in sync with LOOKING_FOR_OPTION_KEYS on the frontend.
var MortgageDifferentOptionLookingFor;
(function (MortgageDifferentOptionLookingFor) {
    MortgageDifferentOptionLookingFor["lowerMonthlyPayment"] = "lowerMonthlyPayment";
    MortgageDifferentOptionLookingFor["getMoreCash"] = "getMoreCash";
    MortgageDifferentOptionLookingFor["payOffDebt"] = "payOffDebt";
    MortgageDifferentOptionLookingFor["changeLoanTerms"] = "changeLoanTerms";
    MortgageDifferentOptionLookingFor["vaOrFhaLoan"] = "vaOrFhaLoan";
    MortgageDifferentOptionLookingFor["getHeloc"] = "getHeloc";
    MortgageDifferentOptionLookingFor["somethingElse"] = "somethingElse";
})(MortgageDifferentOptionLookingFor || (exports.MortgageDifferentOptionLookingFor = MortgageDifferentOptionLookingFor = {}));
/** @TranslateToPython @TranslateToEnum */
var MortgageLender;
(function (MortgageLender) {
    MortgageLender["rocketMoney"] = "rocketMoney";
    MortgageLender["carrington"] = "carrington";
})(MortgageLender || (exports.MortgageLender = MortgageLender = {}));
var MortgageUniformResidentialLoanApplicationStatus;
(function (MortgageUniformResidentialLoanApplicationStatus) {
    MortgageUniformResidentialLoanApplicationStatus["addressHistory"] = "addressHistory";
    MortgageUniformResidentialLoanApplicationStatus["dependents"] = "dependents";
    MortgageUniformResidentialLoanApplicationStatus["subjectProperty"] = "subjectProperty";
    MortgageUniformResidentialLoanApplicationStatus["otherProperties"] = "otherProperties";
    MortgageUniformResidentialLoanApplicationStatus["otherAssets"] = "otherAssets";
    MortgageUniformResidentialLoanApplicationStatus["declarationQuestions"] = "declarationQuestions";
    MortgageUniformResidentialLoanApplicationStatus["hmda"] = "hmda";
    MortgageUniformResidentialLoanApplicationStatus["employmentHistory"] = "employmentHistory";
    MortgageUniformResidentialLoanApplicationStatus["otherIncome"] = "otherIncome";
    MortgageUniformResidentialLoanApplicationStatus["confirmation"] = "confirmation";
    MortgageUniformResidentialLoanApplicationStatus["submitted"] = "submitted";
})(MortgageUniformResidentialLoanApplicationStatus || (exports.MortgageUniformResidentialLoanApplicationStatus = MortgageUniformResidentialLoanApplicationStatus = {}));
/**
 * Ordered page cursor for the rebuilt mortgage intake flow, gated on the mortgageExtendedApplication experiment. Each
 * value names the page the applicant is currently ON; submitting that page advances the cursor. Later pages get
 * appended as they are built.
 *
 * The last page before `complete` owns the handoff to the URLA microflow by calling
 * beginUniformResidentialLoanApplicationMicroflow — currently homeOwner. Appending a page moves that handoff onto the
 * new page, since without it reaching `complete` would leave the application with no URLA cursor and a fresh session
 * would resume at prequal.
 *
 * Values are listed in flow order, and MORTGAGE_EXTENDED_APPLICATION_STATUS_ORDER in the backend encodes that order to
 * keep the cursor monotonic — keep the two in sync when appending.
 */
var MortgageExtendedApplicationStatus;
(function (MortgageExtendedApplicationStatus) {
    MortgageExtendedApplicationStatus["refiConfirm"] = "refiConfirm";
    MortgageExtendedApplicationStatus["propertyType"] = "propertyType";
    MortgageExtendedApplicationStatus["propertyValue"] = "propertyValue";
    MortgageExtendedApplicationStatus["homeOwner"] = "homeOwner";
    MortgageExtendedApplicationStatus["complete"] = "complete";
})(MortgageExtendedApplicationStatus || (exports.MortgageExtendedApplicationStatus = MortgageExtendedApplicationStatus = {}));
exports.MORTGAGE_LIABILITY_DETAIL_FIELDS = ['id', 'monthlyPaymentAmount', 'unpaidBalanceAmount', 'creditorName', 'liabilityIntent'];
exports.MORTGAGE_VALID_LIABILITY_TYPES_FOR_DEBT_REFINANCE = [
    vesta_1.VestaLiabilityType.RevolvingCreditLine,
    vesta_1.VestaLiabilityType.UnsecuredInstallment,
    vesta_1.VestaLiabilityType.SecuredInstallment,
    vesta_1.VestaLiabilityType.HELOC,
    vesta_1.VestaLiabilityType.HomeEquityLoan,
];
exports.MORTGAGE_INVALID_LIABILITY_SUBTYPES_FOR_DEBT_REFINANCE = [vesta_1.VestaLiabilitySubtype.Educational];
// TODO(william.qin): add more actions to resolve qual issues, currently all expected non-qual situations are routed to MLO_INVESTIGATE
var MortgageQualificationAction;
(function (MortgageQualificationAction) {
    MortgageQualificationAction["SHOW_DOC_PORTAL"] = "SHOW_DOC_PORTAL";
    // need MLO to investigate
    MortgageQualificationAction["MLO_INVESTIGATE"] = "MLO_INVESTIGATE";
    // unexpected state
    MortgageQualificationAction["SYSTEM_ERROR"] = "SYSTEM_ERROR";
})(MortgageQualificationAction || (exports.MortgageQualificationAction = MortgageQualificationAction = {}));
exports.MORTGAGE_BASE_REFINANCE_OFFER_LOAN_AMORTIZATION_TYPES = [vesta_1.VestaLoanAmortizationType.AdjustableRateMortgage, vesta_1.VestaLoanAmortizationType.FixedRateMortgage];
const isLoanAmortizationTypeSupported = (amortizationType) => {
    return exports.MORTGAGE_BASE_REFINANCE_OFFER_LOAN_AMORTIZATION_TYPES.includes(amortizationType);
};
exports.isLoanAmortizationTypeSupported = isLoanAmortizationTypeSupported;
var CashOutAmountLimitReason;
(function (CashOutAmountLimitReason) {
    CashOutAmountLimitReason["CONVENTIONAL_LOAN_LIMIT"] = "CONVENTIONAL_LOAN_LIMIT";
    CashOutAmountLimitReason["LOAN_TO_VALUE_RATIO"] = "LOAN_TO_VALUE_RATIO";
    CashOutAmountLimitReason["DEBT_TO_INCOME_RATIO_WITH_BUFFER"] = "DEBT_TO_INCOME_RATIO_WITH_BUFFER";
})(CashOutAmountLimitReason || (exports.CashOutAmountLimitReason = CashOutAmountLimitReason = {}));
/**
 * Where a home owner row came from, which decides where a selection of it can be recorded.
 */
var MortgageHomeOwnerSource;
(function (MortgageHomeOwnerSource) {
    // Resolves to an applicant on this loan, so the selection can become a borrower owner on the Vesta property.
    MortgageHomeOwnerSource["applicant"] = "applicant";
    // A name off the property's title report that matched no applicant. Vesta has no entity for an owner who is not a
    // borrower, so a selection of one of these can only be recorded as a note on the loan.
    MortgageHomeOwnerSource["titleReport"] = "titleReport";
})(MortgageHomeOwnerSource || (exports.MortgageHomeOwnerSource = MortgageHomeOwnerSource = {}));
/** @TranslateToPython @TranslateToEnum */
var DebtObligationType;
(function (DebtObligationType) {
    DebtObligationType["MORTGAGE"] = "mortgage";
    DebtObligationType["SUBORDINATE_LIEN"] = "second_lien";
    DebtObligationType["AUTO"] = "auto_loan";
    DebtObligationType["PERSONAL"] = "personal_loan";
    DebtObligationType["CREDIT_CARD"] = "credit_card";
    DebtObligationType["STUDENT_LOAN"] = "student_loan";
    DebtObligationType["GOVERNMENT"] = "government_loan";
    DebtObligationType["SECOND_LIEN"] = "second_lien";
    DebtObligationType["OTHER"] = "other_liability";
})(DebtObligationType || (exports.DebtObligationType = DebtObligationType = {}));
